/* unplugin-vue-components disabled */import script from "./HomeM.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeM.vue?vue&type=script&setup=true&lang=js"

import "./HomeM.vue?vue&type=style&index=0&id=88d4ae42&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e16590e957a4dff7099c04c4dde027e6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88d4ae42"]])

export default __exports__